module.exports = __webpack_public_path__ + "static/img_pledge_interview_04-85fe0f959e1919a44988051fabd06362.png";